import { add, isPast } from 'date-fns';

import {
  PRODUCT_DISPATCH_DEFAULT,
  PRODUCT_DISPATCH_DEFAULT_FRAMED,
} from '../constants/product';
import { formatDateRange } from './datetime';

const UNFRAMED_DAYS_OFFSET = 7;
const FRAMED_DAYS_OFFSET = 21;

export type DispatchDate = {
  isPast: boolean;
  range: string | null;
  weeks: number | null;
  from?: string;
  to?: string;
};

interface Props {
  framed: boolean;
  framedDispatchDate: string | null;
  launchDate: string | null;
  unframedDispatchDate: string | null;
}

export const getDispatchDate = ({
  framed,
  framedDispatchDate,
  launchDate,
  unframedDispatchDate,
}: Props): DispatchDate => {
  const dispatchDate = framed ? framedDispatchDate : unframedDispatchDate;

  const getDispatchText = (date: Date, offset = 0) => {
    const from = add(date, { days: offset });

    return {
      isPast: isPast(date),
      range: formatDateRange(date, offset, UNFRAMED_DAYS_OFFSET),
      weeks: framed
        ? PRODUCT_DISPATCH_DEFAULT_FRAMED
        : PRODUCT_DISPATCH_DEFAULT,
      from: from.toISOString(),
      to: add(from, { days: UNFRAMED_DAYS_OFFSET }).toISOString(),
    };
  };

  if (dispatchDate) {
    const date = new Date(dispatchDate);
    return getDispatchText(date);
  }

  if (launchDate) {
    const date = new Date(launchDate);
    const offset = framed ? FRAMED_DAYS_OFFSET : UNFRAMED_DAYS_OFFSET;
    return getDispatchText(date, offset);
  }

  return { isPast: false, range: null, weeks: null };
};
